import { useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./contexts/AuthContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import ToastProvider from "./components/admin/ToastProvider";
import HomePage from "./pages/HomePage";
import AdminDashboard from "./pages/AdminDashboard";
import AdminBookingManagement from "./pages/AdminBookingManagement";
import AdminGallery from "./pages/admin/AdminGallery";
import AdminTestimonials from "./pages/admin/AdminTestimonials";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminPackages from "./pages/admin/AdminPackages";
import AdminFAQ from "./pages/admin/AdminFAQ";
import AdminSettings from "./pages/admin/AdminSettings";
import PublicTestimonialForm from "./pages/PublicTestimonialForm";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import ComparePackages from "./pages/ComparePackages";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminLayout from "./components/admin/AdminLayout";
import BookingForm from "./components/BookingForm";
import BookingConfirmation from "./components/BookingConfirmation";
import Gallery from "./components/Gallery";
import CustomCursor from "./components/ui/CustomCursor";
import ScrollToTop from "./components/ui/ScrollToTop";
import SplashScreen from "./components/ui/SplashScreen";
import "./App.css";

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <div key={location.pathname} className="page-transition">
      <Routes>
      <Route path="/" element={<HomePage />} />

      {/* Admin Routes with Layout */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="bookings" element={<AdminBookingManagement />} />
        <Route path="gallery" element={<AdminGallery />} />
        <Route path="testimonials" element={<AdminTestimonials />} />
        <Route path="categories" element={<AdminCategories />} />
        <Route path="packages" element={<AdminPackages />} />
        <Route path="faq" element={<AdminFAQ />} />
        <Route path="settings" element={<AdminSettings />} />
      </Route>

      {/* Public Routes */}
      <Route path="/booking" element={<BookingForm />} />
      <Route path="/booking/confirmation" element={<BookingConfirmation />} />
      <Route path="/gallery" element={<Gallery />} />
      <Route path="/gallery/:category" element={<Gallery />} />
      <Route path="/compare" element={<ComparePackages />} />
      <Route path="/testimoni" element={<PublicTestimonialForm />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
    </Routes>
    </div>
  );
}

function App() {
  const [splashDone, setSplashDone] = useState(
    () => sessionStorage.getItem("splashShown") === "true"
  );

  const handleSplashFinish = () => {
    sessionStorage.setItem("splashShown", "true");
    setSplashDone(true);
  };

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <ToastProvider>
          <AuthProvider>
            <SettingsProvider>
              <div className="App">
                {!splashDone && (
                  <SplashScreen onFinish={handleSplashFinish} />
                )}
                <div
                  className={`transition-opacity duration-700 ${
                    splashDone ? "opacity-100" : "opacity-0"
                  }`}
                >
                  <CustomCursor />
                  <AnimatedRoutes />
                </div>
              </div>
            </SettingsProvider>
          </AuthProvider>
        </ToastProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
